import axios from 'axios'

const Api = {
    getIp: async () => {    
         return await axios.get('https://api.ipify.org/?format=json') 
    },

}
export default Api